import React from "react";
import { useBillingPlans } from "../../../../../context/billingPlans";
import { useMembers } from "../../../../../context/members/MembersProvider";
import classNames from "../../../../../utils/classNames";
import { getCardIcon } from "../BillingDetails";

interface Props {
  onClickCard?: (isNew?: boolean) => void;
}

const CardList: React.FC<Props> = ({ onClickCard }) => {
  const { defaultPaymentMethod, paymentMethods, newPlan, setNewPlan, loading } =
    useBillingPlans();
  const { isCurrentUserAdmin } = useMembers();

  return (
    <div className="flex w-full items-center overflow-x-auto">
      {loading.paymentMethods ? (
        <div className="flex w-full items-center">
          {dummyArray.map((_, index) => (
            <div
              style={{ minWidth: "158px", maxWidth: "158px" }}
              key={index}
              className="flex w-3/12 py-10 mr-5 rounded bg-gray-300 dark:bg-gray-600 animate-pulse shadow-md"
            />
          ))}
        </div>
      ) : (
        <>
          {paymentMethods?.map((item) => (
            <div
              style={{ minWidth: "158px" }}
              key={item.id}
              onClick={() => {
                if (!isCurrentUserAdmin) return;

                setNewPlan((prevState) => ({
                  ...prevState,
                  paymentMethod: item
                }));

                onClickCard && onClickCard();
              }}
              className={classNames(
                item.id === newPlan.paymentMethod?.id &&
                  "border border-yellow-400 dark:border-yellow-400",
                "flex justify-center first:ml-0 last:mr-0 mr-5 items-start flex-col px-3 py-4 bg-white dark:bg-gray-700 border dark:border-transparent dark:hover:border-yellow-400 hover:border-yellow-400 shadow-md rounded-md cursor-pointer"
              )}
            >
              <div className="flex items-center w-full justify-between">
                <span>{getCardIcon(item.card.brand)}</span>
                {item.id === defaultPaymentMethod?.id && (
                  <span className="text-xs dark:text-gray-200 font-semibold">
                    DEFAULT
                  </span>
                )}
              </div>
              <span className="text-sm mt-2 dark:text-gray-200">
                xxxx xxxx xxxx {item.card.last4}
              </span>
            </div>
          ))}
          {isCurrentUserAdmin && (
            <div
              onClick={() => {
                onClickCard && onClickCard(true);
                setNewPlan((prevState) => ({
                  ...prevState,
                  paymentMethod: null
                }));
              }}
              style={{ minWidth: "170px" }}
              className="flex pr-20 justify-center items-start flex-col px-3 py-3.5 bg-white dark:bg-gray-700 rounded-md cursor-pointer border dark:border-transparent hover:border-yellow-400 dark:hover:border-yellow-400 shadow-md"
            >
              <div>{getCardIcon()}</div>
              <span className="text-sm mt-2">+ Add card</span>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CardList;

//
// Utils
//

const dummyArray = ["1", "2", "3"];
